export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8227.3fb090b3.jpg";